(ns quuppa.qsm.release.events
  (:require [re-frame.core :as rf]
            ["@js-joda/core" :as joda]
            [quuppa.utils :as u]))

(rf/reg-event-db
  :release/available-releases-for-channel
  (fn [db [_ qpe-identity channel available-releases]]
    (let [path [:qpes qpe-identity :releases :available-releases channel]]
      (-> db
          (assoc-in (conj path :data) available-releases)
          (update-in path dissoc :error)))))

(rf/reg-event-db
  :release/releases-for-channel-failed
  (fn [db [_ qpe-identity channel error]]
    (assoc-in db [:qpes qpe-identity :releases :available-releases channel :error] error)))

(rf/reg-event-db
  :release/qpe-boot-update-information
  (fn [db [_ qpe-identity qpe-boot-update-information]]
    (assoc-in db [:qpes qpe-identity :releases :qpe-boot-update-information] qpe-boot-update-information)))

(rf/reg-event-db
  :release/download-status
  (fn [db [_ qpe-identity {:keys [channel version-id] :as status}]]
    (if version-id                                          ;; newer QPEs report channel+version-id in status updates
      (update-in db [:qpes qpe-identity :releases :download-status channel version-id] merge status)
      (assoc-in db [:qpes qpe-identity :releases :download-status] status))))

(rf/reg-event-db
  :release/clear-download-status
  (fn [db [_ qpe-identity]]
    (update-in db [:qpes qpe-identity :releases] dissoc :download-status)))

(rf/reg-event-fx :release/restart-qpe
  (fn [{:keys [db]} [_ qpe-identity upgrade-info]]
    (let [server-info (get-in db [:qpes qpe-identity :server-info])
          engine-name (->> server-info
                           :qpe-metadata
                           :name)]
      {:fx [[:server-dispatch {:event      [:qsm/qpe-restart-for-upgrade
                                            {:qpe-identity      qpe-identity
                                             ;; TODO: can legacy-no-ack? be removed when all QPEs have commit 34b78fd (v0.3.0-stable)
                                             ;; version-id added in QPE.next commit c0279f3b
                                             ;; also in the same feature in commit 34b78fd added the ack from QPE
                                             ;; missing version-id can be used to identify "legacy"
                                             ;; QPEs who do not send this information on :release/download-status
                                             :legacy-no-ack?    (nil? (:downloaded-version-id upgrade-info))
                                             :uberjar-file-name (:uberjar-file-name upgrade-info)
                                             :channel           (:upgrade-channel upgrade-info)
                                             :version-id        (:upgrade-version-id upgrade-info)
                                             :version           (:upgrade-version upgrade-info)}]
                               :on-success [:release/qpe-upgrading qpe-identity upgrade-info]
                               :on-error   [:release/restart-failed qpe-identity upgrade-info]}]
            [:dispatch [:notifications/notify
                        {:id         :qpe-restarts-for-upgrade
                         :type       :warning
                         :timeout-ms 30000
                         :heading    (str "Engine " engine-name " is restarting. Please wait.")}]]]
       :db (assoc-in db [:qpes qpe-identity :releases :upgrade] (assoc upgrade-info :state :pending))})))

(rf/reg-event-fx :release/qpe-upgrading
  (fn [{:keys [db]} [_ qpe-identity upgrade-info _]]
    {:db (-> db
             (assoc-in [:qpes qpe-identity :releases :upgrade] (assoc upgrade-info :state :started :started (joda/Instant.now)))
             (update-in [:qpes qpe-identity :releases] dissoc :download-status))
     :fx [:dispatch [:notifications/clear-notification :qpe-restarts-for-upgrade]]}))

(rf/reg-event-fx :release/restart-failed
  (fn [{:keys [db]} [_ qpe-identity _upgrade-info error]]
    {:fx [[:dispatch [:notifications/notify error]]]
     :db (-> db
             (assoc-in [:qpes qpe-identity :releases :upgrade :error] error)
             (assoc-in [:qpes qpe-identity :releases :upgrade :state] :error))}))

(rf/reg-event-fx :release/qpe-version-changed
  (fn [{:keys [db]} [_ qpe-identity new-version]]
    (when-let [{:keys [upgrade-version from-version state] :as upgrade} (get-in db [:qpes qpe-identity :releases :upgrade])]
      ;; sc-25477 only apply this logic when we have upgrade restart "ack" from QPE
      (when (= :started state)
        (let [server-info (get-in db [:qpes qpe-identity :server-info])
              engine-name (->> server-info
                               :qpe-metadata
                               :name)]
          (cond
            (= upgrade-version new-version)
            {:db (update-in db [:qpes qpe-identity :releases] dissoc :upgrade :download-status)
             :fx [[:dispatch [:notifications/notify
                              {:id         :qpe-back-online
                               :timeout-ms 10000
                               :type       :success
                               :heading    (str "Engine " engine-name " is back online")
                               :message    (str (u/str-format "Successfully updated to version %s (previous version %s)."
                                                              new-version
                                                              (:from-version upgrade))
                                                (when-not (= (:upgrade-channel upgrade) (:from-channel upgrade))
                                                  (u/str-format " Also release channel changed from %s to %s"
                                                                (:from-channel upgrade) (:upgrade-channel upgrade))))}]]]}
            (= new-version from-version)
            nil                                               ; component initialized again, do nothing and wait if version would change

            :else
            (do
              (js/console.warn (u/str-format "Version mismatch after upgrade: %s (expected) vs %s (actual)" upgrade-version new-version))
              {:db (update-in db [:qpes qpe-identity :releases] dissoc :upgrade :download-status)})))))))

(rf/reg-event-fx
  :qsm/fetch-qpe-releases-for-channel
  (fn [_ [_ qpe-identity selected-channel]]
    {:fx [[:server-dispatch {:event      [:qsm/fetch-qpe-releases-for-channel {:qpe-identity     qpe-identity
                                                                               :selected-channel selected-channel}]
                             :on-success [:release/available-releases-for-channel qpe-identity selected-channel]
                             :on-error   [:release/releases-for-channel-failed qpe-identity selected-channel]}]]}))

(rf/reg-event-fx
  :qsm/qpe-boot-check-updates
  (fn [_ [_ qpe-identity]]
    {:fx [[:server-dispatch {:event      [:qsm/qpe-boot-check-updates {:qpe-identity qpe-identity}]
                             :on-success [:release/qpe-boot-update-information qpe-identity]
                             :on-error   [:notifications/notify]}]]}))

(rf/reg-event-fx
  :qsm/qpe-start-download
  (fn [{:keys [db]} [_ qpe-identity event-data]]
    {:db (-> db
             (assoc :release/download-ack-missing? true)
             (update-in [:qpes qpe-identity :releases] dissoc :upgrade))
     :fx [[:server-dispatch {:event      [:qsm/qpe-start-download (assoc event-data :qpe-identity qpe-identity)]
                             :on-success [:qsm/qpe-download-started]
                             :on-error   [:qsm/qpe-failed-download-start]}]]}))

(rf/reg-event-db :qsm/qpe-download-started
  (fn [db _]
    (assoc db :release/download-ack-missing? false)))

(rf/reg-event-fx :qsm/qpe-failed-download-start
  (fn [{:keys [db]} [_ event-error]]
    {:db (assoc db :release/download-ack-missing? false)
     :fx [[:dispatch [:notifications/notify event-error]]]}))

(rf/reg-sub :release/download-ack-missing?
  (fn [db]
    (:release/download-ack-missing? db)))


(rf/reg-event-fx
  :qsm/get-available-release-channels
  (fn [_ _]
    {:fx [[:server-dispatch {:event      [:qsm/list-qpe-release-channels]
                             :on-success [:qsm/set-qpe-release-channels]
                             :on-error   [:qsm/list-qpe-release-channels-error]}]]}))

(rf/reg-event-db
  :qsm/set-qpe-release-channels
  (fn [db [_ release-channels]]
    (-> db
        (assoc-in [:releases :available-release-channels] release-channels)
        (dissoc :qsm/list-qpe-release-channels-error))))

(rf/reg-event-db :qsm/list-qpe-release-channels-error
  (fn [db [_ error]]
    (-> db
        (assoc :qsm/list-qpe-release-channels-error error)
        (assoc-in [:releases :available-release-channels] []))))

(rf/reg-sub :qsm/list-qpe-release-channels-error
  (fn [db]
    (:qsm/list-qpe-release-channels-error db)))

(rf/reg-event-db
  ::previous-installation
  (fn [db [_ qpe-identity previous-installation]]
    (assoc-in db [:qpes qpe-identity :previous-installation] previous-installation)))

(rf/reg-event-fx
  :qsm/fetch-previous-installations
  (fn [_ [_ qpe-identity]]
    {:fx [[:server-dispatch {:event      [:qsm/fetch-previous-installations {:qpe-identity qpe-identity}]
                             :on-success [::previous-installation qpe-identity]
                             :on-error   [:notifications/notify]}]]}))
